import "core-js/modules/es.error.cause.js";
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, unref as _unref, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "dialog-footer"
};
import { ref, watch } from 'vue';
import dayjs from 'dayjs';
import { ElMessage } from 'element-plus';
import { addEnterprise } from '@/api/tenant';
import { shortcuts } from '@/constant';
export default {
  __name: 'Applink',
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    data: {
      type: Object,
      default: () => {}
    }
  },
  emits: ['update:modelValue', 'close', 'getData'],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const emit = __emit;
    const ruleFormRef = ref(null);
    watch(() => props.data, val => {
      form.value = {
        username: props.data.username,
        password: '',
        expireDate: dayjs(props.data.expireDate).format('YYYY-MM-DD HH:mm:ss')
      };
    });
    const form = ref({
      username: props.data.username,
      password: '',
      expireDate: dayjs(props.data.expireDate).format('YYYY-MM-DD HH:mm:ss')
    });
    const validateExpireDate = (rule, value, callback) => {
      if (+new Date(value) < +new Date(dayjs(Date.now()).format('YYYY-MM-DD'))) {
        return callback(new Error('过期时间不能小于当前时间'));
      }
      callback();
    };
    const formRule = {
      username: [{
        required: true,
        message: 'applink账号不能为空',
        trigger: ['change', 'blur']
      }],
      expireDate: [{
        required: true,
        message: '过期时间未选择',
        trigger: 'change'
      }, {
        validator: validateExpireDate,
        trigger: 'change'
      }]
    };
    const submitHandler = async () => {
      try {
        await ruleFormRef.value.validate();
        await addEnterprise({
          ...props.data,
          ...form.value,
          expireDate: dayjs(form.value.expireDate).format('YYYY-MM-DD HH:mm:ss'),
          isChain: props.data.isChain ? 1 : 0,
          isParent: 1
        });
        emit('getData');
        emit('close');
        ElMessage({
          message: '操作成功',
          type: 'success'
        });
      } catch (error) {
        ElMessage({
          message: error.message || '失败',
          type: 'warning'
        });
      }
    };
    const resetForm = () => {
      var _ruleFormRef$value;
      // console.log(ruleFormRef.value)
      (_ruleFormRef$value = ruleFormRef.value) === null || _ruleFormRef$value === void 0 || _ruleFormRef$value.resetFields();
    };
    watch(() => props.modelValue, val => {
      if (val) {
        setTimeout(() => {
          resetForm();
        });
      }
    });
    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_date_picker = _resolveComponent("el-date-picker");
      const _component_el_form = _resolveComponent("el-form");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_dialog = _resolveComponent("el-dialog");
      return _openBlock(), _createBlock(_component_el_dialog, {
        title: "appLink管理",
        onClose: _cache[4] || (_cache[4] = $event => _ctx.$emit('close')),
        "model-value": __props.modelValue,
        onClosed: resetForm,
        "destroy-on-close": "",
        "close-on-click-modal": false
      }, {
        footer: _withCtx(() => [_createElementVNode("span", _hoisted_1, [_createVNode(_component_el_button, {
          onClick: _cache[3] || (_cache[3] = $event => _ctx.$emit('close'))
        }, {
          default: _withCtx(() => [_createTextVNode("取消")]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          onClick: submitHandler
        }, {
          default: _withCtx(() => [_createTextVNode("确认")]),
          _: 1
        })])]),
        default: _withCtx(() => [_createVNode(_component_el_form, {
          "label-width": "150px",
          rules: formRule,
          "status-icon": "",
          model: form.value,
          ref_key: "ruleFormRef",
          ref: ruleFormRef
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "appLink账号",
            prop: "username"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: form.value.username,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => form.value.username = $event)
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "appLink密码",
            prop: "password"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: form.value.password,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => form.value.password = $event)
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "服务过期时间",
            prop: "expireDate"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_date_picker, {
              "unlink-panels": "",
              modelValue: form.value.expireDate,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => form.value.expireDate = $event),
              type: "date",
              placeholder: "请选择过期时间",
              shortcuts: _unref(shortcuts),
              size: "default"
            }, null, 8, ["modelValue", "shortcuts"])]),
            _: 1
          })]),
          _: 1
        }, 8, ["model"])]),
        _: 1
      }, 8, ["model-value"]);
    };
  }
};